import { REDUX,initialState } from "../../constants";

export const setCurrentMenu = (menu = initialState.menu.name) => {
  return { type: REDUX.ACTIVE_MENU,  menu};
};